import script from "./control-total-report.vue?vue&type=script&setup=true&lang=js"
export * from "./control-total-report.vue?vue&type=script&setup=true&lang=js"

import "./control-total-report.vue?vue&type=style&index=0&id=694ccf54&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-694ccf54"]])

export default __exports__